<template>
    <div v-if="isLoaded">
        <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <h4 class="card-title">Lista de valores</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onCreate()" v-b-tooltip title="Cadastrar" v-if="getPermission('listitemvalor.store')"><i class="fa fa-plus"></i></a></li>
                                    <li><a @click="onFilterReset()" v-b-tooltip title="Atualizar listagem"><i class="ft-rotate-cw"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHide()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                    <li><a @click="onActivateDesactivate(1, null, false)" v-b-tooltip title="Ativar Registros"  v-if="getPermission('listitemvalor.status')"><i class="fa fa-thumbs-o-up"></i></a></li>
                                    <li><a @click="onActivateDesactivate(3, null, false)" v-b-tooltip title="Inutilizar Registros"  v-if="getPermission('listitemvalor.status')"><i class="fa fa-thumbs-o-down"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    <div class="card-content">
                        <div class="table-responsive">
                            <div v-if="vuetableFilterRow">
                                <vuetable-filterbar>
                                </vuetable-filterbar>
                            </div>
                        <div class="loadingDataPosition">
                            <div class="loadingData" v-if="loadingData"><div class="loadingDataSpinner"><spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner></div></div>
                            <vuetable ref="vuetable"
                                api-url="/api/listitemvalor"
                                :fields="fields"
                                :css="css"
                                :append-params="moreParams"
                                track-by="lisiteval_id"
                                pagination-path=""
                                @vuetable:load-error="onError"
                                @vuetable:pagination-data="onPaginationData"
                                @vuetable:loaded="onLoaded"
                              >

                              <template slot="actions" slot-scope="props">
                                <div class="custom-actions">
                                    <a @click="onEdit(props.rowData, props.rowIndex)" v-b-tooltip title="Editar"  v-if="getPermission('listitemvalor.update')"><i class="fa fa-edit"></i></a>
                                  </button>
                                </div>
                              </template>
                          </vuetable>
                    </div>
                    <div>
                        <div class='col-md-12'>
                            <div class="pull-left pagination-detail">
                                <vuetable-pagination-info ref="paginationInfo"
                                                          :css="css.pagination"
                                                          info-class="pull-left"
                                ></vuetable-pagination-info>
                            </div>
                            <div class="pull-right m-a-0">
                                <vuetable-pagination ref="pagination"
                                                     :css="css.pagination"
                                                     @vuetable-pagination:change-page="onChangePage"
                                ></vuetable-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
                    <!-- Modal Component -->
                    <b-modal id="modal_form"
                             ref="modal_form"
                             :title="modal_titulo"
                             :ok-title="modal_botao"
                             close-title="Fechar"
                             cancel-title="Cancelar"
                             :ok-disabled=form.errors.any()
                             v-model="showModal"
                             @ok="handleOk">

                   <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
                       <label>Tabela</label>
                       <b-form-input type="text"
                                     placeholder="Tabela"
                                     v-model="form.tabela"
                                     name="tabela"
                                     size="sm">
                       </b-form-input>
                       <b-form-feedback v-text="form.errors.get('tabela')" v-if="form.errors.has('tabela')"></b-form-feedback>

                       <label>Coluna</label>
                       <b-form-input type="text"
                                     placeholder="Coluna"
                                     v-model="form.coluna"
                                     name="coluna"
                                     size="sm">
                       </b-form-input>
                       <b-form-feedback v-text="form.errors.get('coluna')" v-if="form.errors.has('coluna')"></b-form-feedback>

                       <label>Descrição</label>
                       <b-form-input type="text"
                                     placeholder="Descrição"
                                     v-model="form.descr"
                                     name="descr"
                                     size="sm">
                       </b-form-input>
                       <b-form-feedback v-text="form.errors.get('descr')" v-if="form.errors.has('descr')"></b-form-feedback>

                       <label>Valor</label>
                       <b-form-input type="text"
                                     placeholder="Valor"
                                     v-model="form.valor"
                                     name="valor"
                                     size="sm">
                       </b-form-input>
                       <b-form-feedback v-text="form.errors.get('valor')" v-if="form.errors.has('valor')"></b-form-feedback>
                   </form>
                          <div slot="modal-footer" class="w-100">
                                 <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                                 <div class="float-right">
                                     <b-btn @click="showModal=false" variant="secondary">
                                       Fechar
                                     </b-btn>
                                     <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                                       Enviar
                                     </b-btn>
                                 </div>
                          </div>
                      </b-modal>
                  </div>
              </div>
          </section>
      </div>
  </template>
<script>
import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import ListItemValorFilterBar from './ListItemValorFilterBar'

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        'vuetable-filterbar': ListItemValorFilterBar
    },
    data () {
        return {
          dataExport: [],
          modal_titulo: '',
          modal_botao: '',
          modal_acao: '',
          loading: false,
          isDisabled: false,
          loadingData: true,
          showModal: false,
          isFullscreen: false,
          form: new Form({ tabela: '',
                           coluna: '',
                           descr: '',
                           valor: ''
                       }),
        fields: [
          {
              name: '__checkbox',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
          },
          {
            name: 'tabela',
            title: 'Tabela',
            sortField: 'tabela'
          },
          {
            name: 'coluna',
            title: 'Coluna',
            sortField: 'coluna'
          },
          {
            name: 'descr',
            title: 'Descrição',
            sortField: 'descr'
          },
          {
            name: 'valor',
            title: 'Valor',
            sortField: 'valor'
          },
          {
              name: '__slot:actions',   // <----
              title: 'Ações',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
          }
      ],
      css: {
          loadingClass: 'loading',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      moreParams: {}
       }
    },
    mounted() {
        this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
        this.$events.$on('filter-reset', e => this.onFilterReset());
      },
    methods: {
        expandFullscreen() {
            this.isFullscreen = !this.isFullscreen;
        },
        onPaginationData (paginationData) {
          this.$refs.pagination.setPaginationData(paginationData)
          this.$refs.paginationInfo.setPaginationData(paginationData)
        },
        onChangePage (page) {
          this.$refs.vuetable.changePage(page)
        },
        onFilterSet (data_filter) {
            this.loadingData = true;
            this.moreParams = {
                'tabela': data_filter.tabela,
                'coluna': data_filter.coluna,
                'descr': data_filter.descr,
                'valor': data_filter.valor
            }
            Vue.nextTick( () => {this.$refs.vuetable.reload(); })
        },
        onFilterReset () {
            this.loadingData = true;
            this.moreParams = {}
            Vue.nextTick( () => this.$refs.vuetable.refresh())
        },
        onFilterShowHide() {
            if(this.vuetableFilterRow)
            {
                this.$store.commit('setVuetableFilterRow', false);
            }
            else
            {
                this.$store.commit('setVuetableFilterRow', true);
            }
        },
        onLoaded: function () {
            this.dataExport = this.$refs.vuetable.tableData;
            this.loadingData = false;
            this.$store.commit('setVuetableFilterButton', false);
        },
        handleOk(e)
        {
            e.preventDefault();
            if(this.modal_acao=="i")
            {
               this.onStore();
            }
            else
            {
                this.onUpdate(this.form.lisiteval_id);
            }
        },
        onCreate ()
        {
          this.isDisabled = false;
          this.loading = false;
          this.modal_titulo = "Cadastrar";
          this.modal_botao = "Cadastrar";
          this.modal_acao = "i";
          this.form.reset();
          this.$refs.modal_form.show();
        },
        onEdit (data, index)
        {
          this.isDisabled = false;
          this.loading = false;
          this.modal_titulo = "Alterar";
          this.modal_botao = "Alterar";
          this.modal_acao = "u";
          this.form.reset();
          this.form.tabela = data.tabela;
          this.form.coluna = data.coluna;
          this.form.descr = data.descr;
          this.form.valor = data.valor;
          this.form.lisiteval_id = data.lisiteval_id;
          this.$refs.modal_form.show();
        },
        onStore()
        {
            this.loading = true;
            this.isDisabled = true;
            this.form.post('/api/listitemvalor/store').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onUpdate(id)
        {
            this.loading = true;
            this.isDisabled = true;
            this.form.post('/api/listitemvalor/update/'+id).then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onError(response) {
            new ReturnApi(response.response, this, true, true, false);
        },
        getPermission(checkPermission) {
            //return this.getPermissionFw(checkPermission);
            return true;
        },
    },
    computed: {
        vuetableFilterRow: {
          get () {
            return this.$store.state.vuetable.filterRow;
          },
        },
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        }
    }
  }
  </script>
